export const FIELDS = [
  { id: 1, name: "currentPassword" },
  { id: 2, name: "newPassword" },
  { id: 3, name: "repeatNewPassword" },
];
